import React from 'react'
import { toAbsoluteUrl } from '../../_metronic/_helpers'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../_metronic/_partials/controls'


export default function BigCommerce() {
    return (
        <Card>
            <CardHeader title={<span style={{ marginRight: '5px' }}>
                <img src={toAbsoluteUrl("/media/platforms/bigcommerce.png")} alt="" title="BigCommerce Portal" height="32" width="32" style={{ marginRight: '5px' }}></img>BigCommerce - Products Sync
            </span>}>
                <CardHeaderToolbar>
                </CardHeaderToolbar>
            </CardHeader>{" "}
            <CardBody>
            <a
                    type='button'
                    style={{cursor:'not-allowed'}}
                    className='btn btn-outline-primary my-3'
                    // href='https://wixapp.ccdemostore.com/ccdemo_bc/api/product_multi_import.php'
                // onClick={}
                >
                    <i class="fa fa-angle-right" aria-hidden="true"></i> ProductSync Step1
                </a><br />
                <a
                    type='button'
                    className='btn btn-outline-primary'
                    style={{cursor:'not-allowed'}}
                    // href="https://wixapp.ccdemostore.com/ccdemo_bc/api/importProduct.php"
                // onClick={}
                >
                    <i class="fa fa-angle-right" aria-hidden="true"></i> ProductSync Step2
                </a>
            </CardBody>
        </Card>
    )
}
